// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5335":"07257fe1078b7a8b","7226":"272b0dbcd331cd6e"}[chunkId] + ".js";
};